/**
 * Created by huzeyin on 2020/5/12.
 */
import request from '../utils/request'

export function createExerciseTemplate (params) {
  return request.post('./index.php', {
    function: 'createExerciseTemplate',
    template_id: params.template_id,
    template_name: params.template_name,
    test_subject: params.test_subject,
    template_instruction: params.template_instruction,
    test_duration: params.test_duration,
    test_type: params.test_type,
    test_BU: params.test_BU,
    test_time: params.test_time,
    project_code: params.project_code,
    full_score: params.full_score,
    question_marks: params.question_marks
  })
}

export function updateExerciseTemplate (template_id, template_name = '', test_subject = '',
  template_instruction = '', test_duration = '', test_type = '', test_BU = '', test_time = '',
  project_code, full_score, question_marks, section_list_instruction, achieve_arr = [], initial_score,
  keep_score_type, exam_type, answer_deduction_points, pic_arr_str, difficulty_level, allow_retake, html_materials, show_lecture
) {
  return request.post('./index.php', {
    function: 'updateExerciseTemplate',
    template_id,
    template_name,
    test_subject,
    template_instruction,
    test_duration,
    test_type,
    test_BU,
    test_time,
    project_code,
    full_score,
    question_marks,
    section_list_instruction,
    achieve_arr,
    initial_score,
    keep_score_type,
    exam_type,
    answer_deduction_points,
    pic_arr_str,
    difficulty_level,
    allow_retake,
    html_materials,
    show_lecture
  })
}

export function removeExerciseTemplate (template_id) {
  return request.post('./index.php', {
    function: 'removeExerciseTemplate',
    template_id
  })
}

export function addExerciseQuestionToTemplateSection (question_id, section_id) {
  return request.post('./index.php', {
    function: 'addExerciseQuestionToTemplateSection',
    question_id,
    section_id
  })
}

export function removeExerciseQuestionInTemplateSection (question_id, section_id) {
  return request.post('./index.php', {
    function: 'removeExerciseQuestionInTemplateSection',
    question_id,
    section_id
  })
}

export function updateExerciseQuestion (
  question_id,
  question_subject,
  question_year,
  question_level,
  question_competency,
  question_question,
  question_optionA,
  question_optionB,
  question_optionC,
  question_optionD,
  question_optionE,
  question_answer,
  extra_index,
  achieve_arr,
  question_marks,
  question_type,
  question_input_restrict,
  question_reference_answer,
  question_scoring_rubric,
  question_group,
  question_article,
  question_optionA_versionB,
  question_optionB_versionB,
  question_optionC_versionB,
  question_optionD_versionB,
  question_optionE_versionB
) {
  return request.post('./index.php', {
    function: 'updateExerciseQuestion',
    question_id,
    question_subject,
    question_year,
    question_level,
    question_competency,
    question_question,
    question_optionA,
    question_optionB,
    question_optionC,
    question_optionD,
    question_optionE,
    question_answer,
    extra_index,
    achieve_arr,
    question_marks,
    question_type,
    question_input_restrict,
    question_reference_answer,
    question_scoring_rubric,
    question_group,
    question_article,
    question_optionA_versionB,
    question_optionB_versionB,
    question_optionC_versionB,
    question_optionD_versionB,
    question_optionE_versionB
  })
}

export function getExerciseQuestion (question_id) {
  return request.post('./index.php', {
    function: 'getExerciseQuestion',
    question_id
  })
}

export function getExerciseQuestions (params) {
  // 传 page 时走服务端分页(只拉当前页);不传时仍返回全部,兼容旧调用
  var data = { function: 'getExerciseQuestions' }
  if (params && params.page) {
    data.page = params.page
    data.page_size = params.page_size || 50
  }
  return request.post('./index.php', data)
}

export function createExerciseTest (template_id, test_taker_id) {
  return request.post('./index.php', {
    function: 'createExerciseTest',
    template_id,
    test_taker_id
  })
}

export function getExerciseTests () {
  return request.post('./index.php', {
    function: 'getExerciseTests'
  })
}

export function getExerciseTest (test_id) {
  return request.post('./index.php', {
    function: 'getExerciseTest',
    test_id
  })
}

export function findStudentByEmail (email) {
  return request.post('./index.php', {
    function: 'findStudentByEmail',
    email
  })
}

export function getExerciseTemplates (params) {
  // 传 page 时走服务端分页(默认每页 20);不传时仍返回全部,向后兼容
  var data = { function: 'getExerciseTemplates' }
  if (params && params.page) {
    data.page = params.page
    data.page_size = params.page_size || 20
  }
  return request.post('./index.php', data)
}

export function getExerciseTemplate (template_id) {
  return request.post('./index.php', {
    function: 'getExerciseTemplate',
    template_id
  })
}

export function resortQuestionsInTemplate (template_id, questions) {
  return request.post('./index.php', {
    function: 'resortQuestionsInTemplate',
    template_id,
    questions
  })
}

export function uploadBanner (params) {
  return request.post('./index.php', params)
}

export function updateExerciseTemplateSection (section_id, template_id, section_title, section_subtitle, section_instruction, section_material, section_material_type) {
  return request.post('./index.php', {
    function: 'updateExerciseTemplateSection',
    section_id,
    template_id,
    section_title,
    section_subtitle,
    section_instruction,
    section_material,
    section_material_type
  })
}

export function removeExerciseSection (section_id, template_id) {
  return request.post('./index.php', {
    function: 'removeExerciseSection',
    section_id,
    template_id
  })
}

export function getExerciseSection (section_id) {
  return request.post('./index.php', {
    function: 'getExerciseSection',
    section_id
  })
}

export function getExerciseQuestionsByName (search_word) {
  return request.post('./index.php', {
    function: 'getExerciseQuestionsByName',
    search_word
  })
}

export function resortQuestionsInTemplateSection (section_id, questions) {
  return request.post('./index.php', {
    function: 'resortQuestionsInTemplateSection',
    section_id,
    questions
  })
}

export function importCsv (questions) {
  return request.post('./index.php', {
    function: 'importCsv',
    questions
  })
}

export function importCsvInTemplate (questions, section_id) {
  return request.post('./index.php', {
    function: 'importCsvInTemplate',
    questions,
    section_id
  })
}

export function changeSectionQuestionMarks (section_id, marks) {
  return request.post('./index.php', {
    function: 'changeSectionQuestionMarks',
    section_id,
    marks
  })
}

export function BatchDelExerciseQuestionInTemplateSection (param) {
  const paramInfo = Object.assign({}, param, { function: 'BatchDelExerciseQuestionInTemplateSection' })
  return request.post('./index.php', paramInfo)
}

export function sortSection (template_id, sections) {
  return request.post('./index.php', {
    function: 'sortSection',
    template_id,
    sections
  })
}

export function uploadPicBatch (param) {
  return request.post('./index.php', param)
}

export function uploadSectionPicBatch (param) {
  return request.post('./index.php', param)
}

export function removePic (address, template_id) {
  return request.post('./index.php', {
    function: 'removePic',
    template_id,
    address
  })
}

export function changeIndexPic (address, template_id, type) {
  return request.post('./index.php', {
    function: 'changeIndexPic',
    template_id,
    address,
    type
  })
}

export function removeSectionPic (address, section_id) {
  return request.post('./index.php', {
    function: 'removeSectionPic',
    section_id,
    address
  })
}

export function delTemplateRedis (template_id) {
  return request.post('./index.php', {
    function: 'delTemplateRedis',
    template_id
  })
}

export function removeMultiPics (template_id, addresses) {
  return request.post('./index.php', {
    function: 'removeMultiPics',
    template_id,
    addresses
  })
}

export function getProjects (filter) {
  return request.post('./index.php', {
    function: 'getProjects',
    filter
  })
}

export function getQiniuToken () {
  return request.post('./index.php', {
    function: 'getQiniuToken'
  })
}

export function getSingaporeQiniuToken () {
  return request.post('./index.php', {
    function: 'getSingaporeQiniuToken'
  })
}

export function addExportInfo (param) {
  return request.post('./index.php', {
    function: 'addExportInfo',
    ...param
  })
}
